import PropType from 'prop-types';
import { css } from '@emotion/react';

import { trackEvent, TRACK_CATEGORIES, TRACK_LABELS } from 'lib/tracking';

import { colors, fontSize } from 'styles/theme';
import { tapTargetCss } from 'styles/utils';

import Link from 'components/shared/Link/Link';

import ExternalLink from '../ExternalLink/ExternalLink';

const linkCss = css`
  line-height: 0;

  a {
    ${tapTargetCss};

    color: ${colors.white};
    opacity: 0.8;
    line-height: 2.06;
    display: inline-flex;
    align-items: center;
    font-size: ${fontSize.sm};
  }
`;

const iconCss = css`
  margin-right: 12px;
  width: 2.1rem;
  height: 2.1rem;
`;

/**
 * @param {object} props
 */
function FooterLink({ icon, label, newTab, url, redirect }) {
  const Icon = icon;
  const link = redirect ?? url;

  function trackExternalLink() {
    trackEvent(label.toLowerCase(), {
      category: TRACK_CATEGORIES.SOCIAL_CLICK,
      label: TRACK_LABELS.FOOTER,
    });
  }

  const renderedLink = newTab ? (
    <ExternalLink href={link} onClick={trackExternalLink}>
      {icon && <Icon css={iconCss} />} {label}
    </ExternalLink>
  ) : (
    <Link
      track={{
        event: label,
        label: label,
      }}
      href={url}
    >
      {icon && <Icon css={iconCss} />} {label}
    </Link>
  );

  return (
    <li key={url} css={linkCss}>
      {renderedLink}
    </li>
  );
}

FooterLink.propTypes = {
  /** Link's SVG icon */
  icon: PropType.func,
  /** Link's label */
  label: PropType.string.isRequired,
  /** Open link in a new tab, as an external link */
  newTab: PropType.bool,
  /** Link's url */
  url: PropType.string.isRequired,
  redirect: PropType.string,
};

export default FooterLink;
